import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is data analytics, and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Data analytics is the process of collecting, storing, and analyzing data in order
                                        to gain insights and inform business decisions. Data analytics can help
                                        businesses to identify trends and patterns, make better-informed decisions, and
                                        optimize their operations. Businesses leveraging data analytics can gain a
                                        competitive advantage and drive growth and innovation.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the key considerations when selecting data analytics solutions?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>When selecting data analytics solutions, it's important to consider factors such
                                        as the type and volume of data you need to analyze, your specific business needs
                                        and goals, the level of expertise and support you require, and the budget and
                                        resources you have available. Other considerations may include the security and
                                        privacy of your data, the compatibility of the solution with your existing
                                        systems and processes, and the scalability and flexibility of the solution.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Can TekRevol help me with my data analytics needs?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, TekRevol has a team of experienced professionals with expertise in data
                                        analytics. We have a record of success in helping businesses collect, store, and
                                        analyze data to gain insights and inform business decisions. Our team has the
                                        skills and knowledge to help you create a custom data analytics solution that
                                        meets your specific needs and goals. Whether you're looking to improve your
                                        operations, increase your sales, or better serve your customers, we can help you
                                        create a data analytics solution that works for you.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;